import React, {memo} from "react";
import { withStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
//import PersonIcon from "@mui/icons-material/Person";
import Avatar from "@mui/material/Avatar";

import { useStyles } from "./styles";

const UserProfileCard = memo(({ classes, firstName, profilePicURL, onClose }) => {
  console.log('profilePicURL',profilePicURL);
  return (
    <div className={classes.Userdetails}>
      <Avatar className={classes.avatar} src={profilePicURL || '/static/images/avatar-default.svg'}/>
      {/* <PersonIcon /> */}
      <div>
        <h4>{firstName}</h4>
      </div>
      {onClose && <CloseIcon className={classes.closeIcon} onClick={onClose} />}
    </div>
  );
});

UserProfileCard.propTypes = {
  firstName: PropTypes.string,
  onClose: PropTypes.func,
};

export default withStyles(useStyles)(UserProfileCard);
